// Spiegelt die Serverregel require_client_write / ensure_client_write (backend).
const WRITABLE_TEAM_ROLES = ["admin_ops", "projektleitung", "entwickler", "support", "buchhaltung", "content_seo"];

const isSuper = u => u?.role === "super_admin";
const hasWritableRole = u => u?.role === "team_member" && WRITABLE_TEAM_ROLES.includes(u?.team_role);

export const isReadOnlyStaff = u => u?.role === "team_member" && !WRITABLE_TEAM_ROLES.includes(u?.team_role);

export const canCreateClient = u => isSuper(u) || (hasWritableRole(u) && u?.client_scope === "alle");

export const canWriteClient = (u, clientId) => isSuper(u) || (hasWritableRole(u) && (u?.client_scope === "alle"
  || (u?.client_scope === "bestimmte" && !!clientId && (u?.scoped_client_ids || []).includes(clientId))));
